import React, { useState } from 'react';
import { PublicLayout } from '../components/PublicLayout';
import { Image } from 'lucide-react';

const categories = ['Semua', 'Majlis Rasmi', 'Kejuaraan', 'Latihan & Bengkel', 'Komuniti', 'Perasmian'];

const albums = [
  { title: 'Kunjungan Hormat YTY Yang Dipertua Negeri Sarawak', cat: 'Majlis Rasmi', year: 'Terkini' },
  { title: 'Sarawak Premier International Silat Championship 2023', cat: 'Kejuaraan', year: '2023' },
  { title: 'Sukan Malaysia XXI Sarawak 2024', cat: 'Kejuaraan', year: '2024' },
  { title: 'Konvensyen Guru-Guru Silat Negeri Sarawak', cat: 'Latihan & Bengkel', year: 'Terkini' },
  { title: 'RSS Beach Games Mukah 2022', cat: 'Komuniti', year: '2022' },
  { title: 'Perasmian Ibu Pejabat RSS Sarawak', cat: 'Perasmian', year: '2006' },
  { title: 'Sidang Agung Ke-15 RSS Sarawak', cat: 'Majlis Rasmi', year: 'Terkini' },
  { title: 'Kursus Asas Pengenalan Silat', cat: 'Latihan & Bengkel', year: 'Berterusan' },
  { title: 'Rumah Terbuka Aidilfitri RSS Sarawak', cat: 'Komuniti', year: 'Tahunan' },
  { title: 'Kunjungan Hormat kepada YAB Premier Sarawak', cat: 'Majlis Rasmi', year: 'Terkini' },
  { title: 'Kejuaraan Silat Kebangsaan ke-21 2025', cat: 'Kejuaraan', year: '2025' },
  { title: 'Ramah Tamah Aidilfitri Wilayah RSS', cat: 'Komuniti', year: 'Tahunan' },
];

export default function Galeri() {
  const [active, setActive] = useState('Semua');
  const filtered = active === 'Semua' ? albums : albums.filter(a => a.cat === active);

  return (
    <PublicLayout>
      {/* Page Header */}
      <div className="bg-[#0B0B0B] text-white py-16">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-16 mb-16" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-3">Utama / Galeri</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold" data-testid="galeri-title">
            Galeri RSS Sarawak
          </h1>
          <p className="text-[#999] mt-3 text-sm sm:text-base max-w-xl">
            Koleksi dokumentasi gambar aktiviti, program dan majlis rasmi Rumpun Silat Sarawak.
          </p>
        </div>
      </div>

      {/* Category Filter */}
      <div className="bg-white border-b border-[#E5E5E5] py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex gap-2 overflow-x-auto pb-1">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActive(cat)}
                className={`px-3 py-1.5 text-xs font-semibold whitespace-nowrap rounded border transition-colors ${
                  active === cat
                    ? 'bg-[#D71920] text-white border-[#D71920]'
                    : 'bg-white text-[#555] border-[#E5E5E5] hover:border-[#D71920] hover:text-[#D71920]'
                }`}
                data-testid={`cat-filter-${cat}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <section className="bg-[#F7F7F7] py-12 min-h-64">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#999] mb-6">{filtered.length} album</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((album, i) => (
              <div key={i} className="bg-white border border-[#E5E5E5] rounded overflow-hidden hover:shadow-md transition-shadow" data-testid={`album-card-${i}`}>
                <div className="bg-[#F7F7F7] h-44 flex flex-col items-center justify-center border-b border-[#E5E5E5] relative group">
                  <Image size={32} className="text-[#E5E5E5]" />
                  <div className="absolute inset-0 bg-[#0B0B0B]/0 group-hover:bg-[#0B0B0B]/5 transition-colors" />
                  <div className="absolute top-3 right-3">
                    <span className="text-[10px] font-bold bg-white border border-[#E5E5E5] text-[#777] px-2 py-0.5 rounded">
                      {album.year}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-1.5 h-1.5 bg-[#D71920] rounded-full flex-shrink-0" />
                    <span className="text-[10px] font-bold text-[#D71920] uppercase tracking-wide">{album.cat}</span>
                  </div>
                  <h3 className="font-bold text-[#0B0B0B] text-sm leading-snug">{album.title}</h3>
                  <p className="text-xs text-[#bbb] mt-3 italic">Gambar akan dikemaskini</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-8 p-5 bg-white border border-[#E5E5E5] rounded text-sm text-[#666] leading-relaxed">
            Galeri gambar sedang dalam proses kemaskini oleh Sekretariat RSS Sarawak.
            Gambar-gambar aktiviti terkini akan dipaparkan apabila telah disahkan.
            Untuk pertanyaan, sila <a href="/hubungi" className="text-[#D71920] font-medium hover:underline">hubungi kami</a>.
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
